"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = [{
        label: '1',
        value: '1',
        hint: 'Climber controlled the hold',
    }, {
        label: '1+',
        value: '+',
        hint: 'Climber controlled and moved off the hold',
    }, {
        label: 'T',
        value: 'T',
        hint: 'Climber reached the top hold of the climb',
    }];
//# sourceMappingURL=appButtons.js.map


//////////////////
// WEBPACK FOOTER
// ../lib-score-systems/dist/scoreSystems/IfscLead/appButtons.js
// module id = 862
// module chunks = 0